import { EmptyState as EmptyStateComponent } from "@aurem/ui";
import { InboxIcon } from "lucide-react";
import { useI18n } from "providers/I18nProvider";

type Props = {
  variant: "idle" | "noResults";
};

export const EmptyState = ({ variant }: Props) => {
  const { t } = useI18n();

  const title =
    variant === "idle"
      ? t("apps.admin.globalSearch.idle.title")
      : t("apps.admin.globalSearch.noResults.title");

  const text =
    variant === "idle"
      ? t("apps.admin.globalSearch.idle.text")
      : t("apps.admin.globalSearch.noResults.text");

  return (
    <EmptyStateComponent
      size="sm"
      className="mx-auto max-w-[300px] justify-self-center self-center"
      illustration={<InboxIcon size="2rem" className="text-neutral-200" />}
      title={title}
      text={text}
    />
  );
};
